<template>
    <div>
        <img src="../../assets/newImg/index_bg.png" class="index-bg" alt="" />
        <div class="income row-flex row-around-center">
            <div class="come-left">
                <div class="money text-color">
                    {{ incomeMoney.all_amount }}元
                </div>
                <div class="money-txt">累计收入</div>
            </div>
            <div class="li bg-color"></div>
            <div class="come-right">
                <div class="money text-color">
                    {{ incomeMoney.user_all_amount }}元
                </div>
                <div class="money-txt">本期收入</div>
            </div>
        </div>
        <div class="query row-flex row-between-center">
            <div
                class="query-time row-flex row-center-center"
                @click="selectTime"
            >
                <div class="time">{{ time }}</div>
                <img src="../../assets/newImg/up_down.png" alt="" />
            </div>
            <div
                class="query-btn text-color border-color row-flex row-center-center"
                @click="selectMonth"
            >
                查询
            </div>
        </div>
        <div class="income-list">
            <div class="income-li row-flex row-between-center row-column">
                <div class="income-li-top row-flex row-between-center">
                    <div class="left">个人比例收入</div>
                    <div class="money text-color">
                        {{ incomeMoney.user_amount }}元
                    </div>
                </div>
                <div class="income-li-bottom ">
                    {{ incomeMoney.individual_ratio_msg }}
                </div>
            </div>
            <div class="line-li"></div>
            <div class="income-li row-flex row-between-center row-column">
                <div class="income-li-top row-flex row-between-center">
                    <div class="left">直属会员差额奖金</div>
                    <div class="money text-color">
                        {{ incomeMoney.user_reward }}元
                    </div>
                </div>
                <div class="income-li-bottom ">
                    {{ incomeMoney.reward_msg }}
                </div>
            </div>
            <div class="line-li"></div>
            <div class="income-li row-flex row-between-center row-column">
                <div class="income-li-top row-flex row-between-center">
                    <div class="left">推广奖金</div>
                    <div class="money text-color">
                        {{ incomeMoney.promotion_fund }}元
                    </div>
                </div>
                <div class="income-li-bottom ">
                    {{ incomeMoney.extension_msg }}
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-left">
                <img src="../../assets/newImg/warn.png" alt="" />
                <div class="content">
                    {{ incomeMoney.msg }}
                </div>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                @confirm="confirm"
                @cancel="cancel"
            />
        </van-popup>
    </div>
</template>
<style lang="scss" scoped>
.index-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 120px;
    z-index: -1;
}
.income {
    margin: 36px 10px 0 10px;
    height: 106px;
    background: url("../../assets/newImg/incom_bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
    .come-left,
    .come-right {
        width: 50%;
        text-align: center;
        .money {
            font-size: 20px;
            font-weight: 600;
            text-align: justify;
            text-align: center;
        }
        .money-txt {
            color: #333333;
            font-size: 16px;
            padding-top: 15px;
        }
    }
    .li {
        height: 80px;
        width: 1px;
    }
}
.query {
    margin: 13px 10px;
    height: 48px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    padding: 0 14px;
    .query-btn {
        width: 93px;
        height: 30px;
        font-size: 15px;
        border-radius: 4px;
        font-weight: 600;
    }
    .query-time {
        width: 222px;
        height: 30px;
        background: #f8f8f8;
        border-radius: 4px;
        .time {
            font-size: 15px;
            color: #666666;
        }
        img {
            width: 10px;
            height: 13px;
            margin-left: 6px;
        }
    }
}
.income-list {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    margin: 0 11px;
    .income-li {
        width: 100%;
        min-height: 58px;
        padding: 0 15px;
        .income-li-top {
            width: 100%;
            height: 41px;
            .left {
                color: #333333;
                font-weight: 600;
                font-size: 14px;
            }
            .right {
                font-size: 14px;
            }
        }
        .income-li-bottom {
            width: 100%;
            padding-bottom: 15px;
            font-size: 12px;
            color: #999999;
        }
    }
    .line-li {
        height: 1px;
        margin: 0 15px;
        border: 1px solid #f2f2f2;
    }
}
.card {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    padding: 0 11px;
    margin-top: 101px;
}
.card .card-left {
    display: flex;
}
.card img {
    width: 20px;
    height: 20px;
}
.card .content {
    padding-left: 14px;
    font-size: 13px;
    color: #333333;
}
.card .succ {
    width: 52px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #d01112;
    border-radius: 13px;
    color: #fff;
    font-size: 12px;
}
</style>
<script>
import Vue from "vue";
import { DatetimePicker, Popup } from "vant";
import { inCome } from "@api/user";
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
    name: "income",
    data() {
        return {
            show: false,
            currentDate: new Date(),
            time: "",
            incomeMoney: {},
        };
    },
    methods: {
        formatter(type, val) {
            if (type === "year") {
                return `${val}年`;
            } else if (type === "month") {
                return `${val}月`;
            }
            return val;
        },
        /**选择时间 */
        selectTime() {
            this.show = true;
        },
        confirm(e) {
            this.time = this.timestampToTime(e.getTime());
            console.log(this.time);
            this.show = false;
        },
        cancel() {
            this.show = false;
        },
        /**收入 */
        comeMoney() {
            let date = new Date().getTime();
            let params = {
                month: this.time == "" ? this.timestampToTime(date) : this.time,
            };
            inCome(params).then((res) => {
                this.incomeMoney = res.data.data;
                this.time = params.month;
            });
        },
        /**查询 */
        selectMonth() {
            this.comeMoney();
        },
        /**时间戳转时间 */
        timestampToTime(timestamp) {
            var date = new Date(timestamp);
            var Y = date.getFullYear() + "-";
            var M =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            return Y + M;
        },
    },
    mounted() {
        this.comeMoney();
    },
};
</script>
